export class PottyNotesConstants {
	//Pain meter, the index is the 0 - 10 rating on the scale. 0 being satisfaction, 10 being pain.
	public static readonly painMeterFilenameMappings: string[] = [
		"smiling-face-with-sunglasses.svg",
		"relieved-face.svg",
		"face-with-stuck-out-tongue.svg",
		"drooling-face.svg",
		"smiling-face-with-tear.svg",
		"neutral-face.svg",
		"crying-face.svg",
		"confounded-face.svg",
		"hot-face-emoji.svg",
		"dizzy-face.svg",
		"loudly-crying-face.svg"
	]
	// Report Card.
	public static readonly ambianceOne: string = "directionless and lost";
	public static readonly ambianceTwo: string = "it needs candles";
	public static readonly ambianceThree: string = "an effort was made";
	public static readonly ambianceFour: string = "body parts fell asleep";
	public static readonly ambianceFive: string = "absolutely serene";
	public static readonly toiletPaperOne: string = "it was missing";
	public static readonly toiletPaperTwo: string = "might as well be sand paper";
	public static readonly toiletPaperThree: string = "it's fine but i wouldnt buy it";
	public static readonly toiletPaperFour: string = "it's actually soft";
	public static readonly toiletPaperFive: string = "angelic";
	public static readonly comfortOne: string = "get me out of here";
	public static readonly comfortTwo: string = "it's awkward";
	public static readonly comfortThree: string = "ordinary";
	public static readonly comfortFour: string = "pleasant";
	public static readonly comfortFive: string = "luxury";
	public static readonly privacyOne: string = "might as well be in public";
	public static readonly privacyTwo: string = "everyone can hear what's happening";
	public static readonly privacyThree: string = "small cracks to see inside";
	public static readonly privacyFour: string = "no cracks to see inside";
	public static readonly privacyFive: string = "bank vault door";
	public static readonly cleanlinessOne: string = "poop. on. walls.";
	public static readonly cleanlinessTwo: string = "third party urine is present";
	public static readonly cleanlinessThree: string = "teenage definition of clean";
	public static readonly cleanlinessFour: string = "it's actually pretty clean";
	public static readonly cleanlinessFive: string = "impeccable";
	// Describe Secretion.
	public static readonly peeDescriptions: string[] = [
		'Wow I am hydrated',
		'Yellow is happy color',
		'I need to drink more water'
	]
	public static readonly pooDescriptions: string[] = [
		'Basically constipated',
		'Did someone eat playdough',
		'Sausages',
		'Snake-like',
		'It broke apart',
		'Fluffy and light',
		'Explosive'
	]

	// Add thoughts.
	public static readonly placeholderInputs: string[] = [
		'Instead of John, I call my bathroom Jim. It sounds better to say: \"I went to the Jim first thing in the morning.\"',
		'♫ ♫ When you\'re sittin on the john and the toilet papers gone say \'oh man\' ♪ ♪ --- use your hand. ♫ ♫',
		'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
		'Maybe I shouldn\'t have had that last coffee...',
		'Dinosaur poops have been discovered to be 17 inches long and 6 inches thick.',
		'The average tree can produce about 810 rolls of toilet paper.',
		'The average person uses about 295,650 worth of toilet paper in their lifetime.',
		'Colonial americans used to use corn on the cob to wipe their butt.',
		'Believe you can, and you\'re halfway there.',
		'No matter the circumstances, just push through it.',
		'The bigger they come, the harder they fall.'
	]
	// Create diary.
	public static readonly pinLength: number = 5;
	public static readonly maxDiaryTitleLength: number = 27;
	public static readonly minDiaryTitleLength: number = 2;
	// Create account.
	public static readonly minPasswordLength: number = 8;
	public static readonly minNameLength: number = 2;

	public static readonly bathroomFacts: string[] = [
		"The world's most expensive bathroom is located in Hong Kong and cost 5 million $ to build.",
		"The oldest known flush toilet was found in the ancient city of Knossos in Crete, dating back to around 1700 B.C.",
		"Toilet paper was first introduced in the United States in 1857.",
		"The first modern flushing toilet was invented by Sir John Harrington in 1596 for Queen Elizabeth I.",
		"The first public bathrooms in the U.S. opened in Boston in 1829.",
		"The average person visits the toilet about 2,500 times a year.",
		"The term 'restroom' originated in the 1920s as a euphemism for a public toilet.",
		"The Great Wall of China has ancient bathrooms with intricate plumbing systems.",
		"The world's smallest bathroom is only 11 square feet and is located in New York City.",
		"The color blue is often used in bathrooms because it is associated with calmness and cleanliness.",
		"In Japan, some toilets are equipped with heated seats and music to enhance the bathroom experience.",
		"The most common superstition about bathrooms is that you shouldn't look in the mirror at night.",
		"The first shower curtain was made of oilcloth in the 19th century.",
		"Toilets use about 27% of household water consumption in the United States.",
		"The word 'toilet' comes from the French word 'toilette,' which means 'small cloth.'",
		"The average person spends around 6 months of their life in the shower.",
		"The world's largest public bathroom, the Pearl Public Toilet, is in China and has over 1,000 toilets.",
		"The toilet handle in a public restroom can have over 40,000 germs per square inch.",
		"The Romans used a communal sponge on a stick as a primitive form of toilet paper.",
		"The Beatles' song 'Lovely Rita' was written about a woman who worked as a meter maid and inspired by a poster the band saw in a public restroom.",
		"The fear of using public restrooms is known as parcopresis.",
		"In ancient Rome, some public bathrooms had a library for reading and socializing.",
		"The first automatic flushing toilet was invented in 1957 by an American inventor named Harvey Heather.",
		"The world's oldest working flush toilet is located at a castle in Scotland and dates back to the 14th century.",
		"The average person spends about 1.5 years of their life on the toilet.",
		"The toilet brush was invented in 1932 by William C. Schopp.",
		"The most expensive toilet seat is made of gold and is worth over $4,000.",
		"King George II of Great Britain died falling off a toilet on October 25, 1760.",
		"The inventor of the modern flush toilet, Thomas Crapper, did not actually invent the flush toilet, but he did make several improvements to its design.",
		"In Japan, some public restrooms are equipped with noise-making machines to mask embarrassing sounds.",
		"The world's largest bathtub can hold up to 4,000 gallons of water and is located in the United Arab Emirates.",
		"The average person spends about 1 hour and 42 minutes per week in the bathroom.",
		"Toilet paper was originally sold in individual squares.",
		"The world's first coin-operated public toilet was introduced in 1851 in London.",
		"The fear of using public restrooms is known as paruresis.",
		"The toilet is flushed more times during the Super Bowl halftime show than at any other time of the year.",
		"The world's first recorded water closet was built for Queen Elizabeth I in 1596.",
		"The world's most expensive toilet is made of solid gold and is worth $5 million.",
		"In ancient Rome, public toilets were sometimes used for business meetings and discussions.",
		"The world's largest toilet roll was made in Mexico and measured over 1300 feet in length.",
		"The first modern flushable toilet was patented by Alexander Cummings in 1775.",
		"The fear of germs and dirt in bathrooms is known as OCD (Obsessive Compulsive Disorder).",
		"The average person uses about 57 sheets of toilet paper per day.",
		"The word 'bathroom' originated from the French word 'bains,' meaning 'baths.'",
		"The first toilet paper was manufactured in China in the 6th century.",
		"The first urinals were introduced in Ancient Rome and were made of marble.",
		"The world's first public toilet opened in Ancient Rome in 74 AD.",
		"Toilets use more water in the U.S. than is used for the flushing of all other fixtures in the home combined.",
		"The first public restroom in the United States to provide free toilet paper was opened in 1857 in New York City.",
		"The world's most expensive toilet brush is encrusted with diamonds and costs over $97,000.",
		"Astronauts use specially designed toilets in space that rely on airflow instead of gravity.",
		"The world's first automatic flush toilet was invented in 1906 by a man named William Elvis Sloan.",
		"The fear of running out of toilet paper is known as 'tpaphobia.'",
		"The average person spends about 92 days of their life on the toilet.",
		"Toilet paper was originally sold in boxes, not rolls.",
		"In the 16th century, people in Europe used straw, hay, and even seashells as makeshift toilet paper.",
		"The world's most expensive bidet is made of solid gold and is worth over $100,000.",
		"The first toilet seat was made of porcelain and invented in the late 19th century.",
		"In the Middle Ages, people often used moss or leaves as a substitute for toilet paper.",
		"The first toilet paper patent was registered in 1891 by Seth Wheeler.",
		"The world's first flushing toilet for the masses was invented in 1852 by George Jennings.",
		"Toilets use more water than any other household fixture.",
		"The oldest working toilet in England is over 500 years old and is located in a castle.",
		"The average person flushes the toilet about 2,500 times a year.",
		"The world's first toilet paper factory was built in 1857 in the United States.",
		"The fear of using public restrooms is a type of social anxiety disorder.",
		"In some cultures, it is considered polite to flush the toilet before using it to clear away any potential germs.",
		"The world's first two-piece toilet design was introduced in 1900.",
		"The average person spends about 3 hours and 9 minutes per week in the bathroom.",
		"The world's most expensive bathroom sink is made of gold and diamonds and is worth over $80,000.",
		"The first indoor flushing toilet was invented by John Harington in the late 16th century.",
		"Toilet paper was first commercially packaged and sold in rolls in 1871.",
		"The world's most expensive toilet paper is made of 22-carat gold flakes and costs over $1.3 million.",
		"The toilet is often the dirtiest item in a bathroom, even dirtier than the floor.",
		"The first toilet cubicle was introduced in 1820 by an Englishman named George Jennings.",
		"The world's first commercial flush toilet was introduced in 1851 at the Great Exhibition in London.",
		"The average person spends about 3 years and 3 months of their life on the toilet.",
		"Toilet paper was first used by the Chinese in the 6th century but didn't become widespread until the 14th century.",
		"The world's most expensive toilet roll is made of 22-carat gold and is worth over $1 million.",
		"The toilet handle is usually the germiest part of the bathroom.",
		"The average person uses the toilet 6-8 times per day.",
		"The world's first multi-stall public toilet was introduced in 1852 in London.",
		"Toilets account for approximately 30% of residential indoor water use in the United States.",
		"The fear of using public restrooms is more common among women than men.",
		"The first patent for a flushing toilet was granted to Alexander Cummings in 1775.",
		"The world's most expensive toilet paper holder is made of gold and is worth over $4,000.",
		"The average person spends about 14 hours per month in the bathroom.",
		"The world's first coin-operated toilet was introduced in 1910 in Paris.",
		"The first bidet was invented in the early 18th century in France.",
		"The average person visits the bathroom 6-7 times per day.",
		"The world's most expensive toilet seat cover is made of crocodile leather and is worth over $2,500.",
		"Toilets are responsible for over 40% of the water usage in the average American home.",
		"The first public restroom with separate male and female facilities was introduced in 1739 in Paris.",
		"The average person spends about 6 months of their life waiting for the toilet to be available.",
		"The world's most expensive toilet brush holder is made of gold and is worth over $1,000.",
		"The first toilet paper in the United States was sold in packages of flat sheets.",
		"The fear of using public restrooms is known as 'lutrinesophobia.'",
		"The average person spends about 3 years and 9 months of their life in the bathroom.",
		"Toilet paper was first introduced in the United States in 1857.",
		"The world's most expensive bathroom is located in Hong Kong and cost $5 million to build.",
		"The oldest known flush toilet was found in the ancient city of Knossos in Crete, dating back to around 1700 B.C.",
		"The first modern flushing toilet was invented by Sir John Harrington in 1596 for Queen Elizabeth I.",
		"The first public bathrooms in the U.S. opened in Boston in 1829.",
	];

	public static readonly guestbookTitles: string[] = [
		"🚽 Throne Room Chronicles",
		"💩 Tales From The Seat",
		"🧻 Roll Call Vol 1",
		"🚽 Royal Flush Diaries",
		"💫 Potty Thoughts 101",
		"💩 The Daily Business",
		"⭐ Sit Happens Vol 2",
		"🚽 Flush and Tell Stories",
		"💫 Porcelain Confessions",
		"⚡ The Numba 2 Logbook",
		"🚽 Bathroom Brilliance",
		"🎭 Stall Stories",
		"✨ Powder Room Papers",
		"🎪 The Great Relief",
		"💩 Loo and Behold",
		"🌟 The Grand Poopendium",
		"🚽 Toilet Tales and More",
		"⭐ Restroom Ramblings",
		"💫 The Royal Readers",
		"🎭 Privy Poetry Vol 3",
		"✨ Latrine Laughs 2024",
		"🚽 Bathroom Buzz Daily",
		"💩 Commode Commentary",
		"⚡ Flush Hour Notes",
		"💫 The Oval Office Log"
	]
}

export enum ValidationErrors {
	REQUIRED = 'Required.',
	EMAIL = 'Invalid email format.',
	MIN_LENGTH_2 = 'At least 2 characters.',
	MIN_LENGTH_8 = 'At least 8 characters.',
	MISMATCH = 'Passwords do not match.',
	ONLYLETTERS = 'No numbers or special characters.'
}
